import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

interface Label {
    id: number;
    label: string;
}

interface HelpContent {
    title: string;
    labels: Label[];
}

@Component({
    selector: 'density-help-accordion',
    templateUrl: './density-help-accordion.component.html',
    styleUrl: './density-help-accordion.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DensityHelpAccordionComponent {
    @Input()
    header: string = '';

    @Input()
    content: HelpContent = { title: '', labels: [] };

    @Input()
    loading: boolean | null = false;

    @Input()
    isOpen: boolean = false;

    @Output()
    isOpenChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    isOpenChange(isOpen: boolean) {
        this.isOpen = isOpen;
        this.isOpenChanged.emit(this.isOpen);
    }
}
